export const PRIMARY = '#0500A3';
export const ACCENT = '#E8CD00';
export const SUCCESS = '#6ED230';
export const DANGER = '#DF4547';
export const WARNING = '#E09307';
export const INFO = '#62B1F6';
export const FOO = '#5D72F7';

export const WARNING_BG = '#F5CCCC';
export const WARNING_BORDER = '#D9B7B8'; //'#E55E5E';
export const WARNING_LABEL = '#660000'; //'#E55E5E';

export const BACKGROUND = '#EAEEF6';
export const BACKGROUND_HEADER = '#DEDEDE';
export const BACKGROUND_SCREEN = '#F9F9FA';
export const BACKGROUND_PROJECT_CARD = '#727491';
export const LABEL = '#6F6F6F';

export const BLACK = '#000000';
export const GRAY = '#DFDFDF';
export const PURPLE = '#A451BA';
export const WHITE = '#FFFFFF';

// export const SHADOW = '#999BA8';
export const SHADOW = '#777777';
export const TRANSPARENT = 'transparent';

export const GRAY_LIGHT = '#EAEEF5'; //'#E6E6E6';
export const GRAY_MEDIUM = '#CACACA';
export const GRAY_DARK = '#717491';

export const SUCCESS_DARK = '#618817';

export const PURPLE_LIGHT = '#E5E7FC';
export const BAR = '#F8F8F8';

export const CHECK = '#7CCE2D';
export const UNCHECK = '#DF4547';

export const BORDER = '#E0E0E0';

export const getButtonTheme = props => {
  const isOutline = props.outline;
  let color = isOutline ? PRIMARY : WHITE;
  let backgroundColor = isOutline ? WHITE : PRIMARY;

  if (props.accent) {
    color = isOutline ? ACCENT : PRIMARY;
    backgroundColor = isOutline ? WHITE : ACCENT;
  } else if (props.danger) {
    color = isOutline ? DANGER : WHITE;
    backgroundColor = isOutline ? WHITE : DANGER;
  } else if (props.warning) {
    color = isOutline ? WARNING : WHITE;
    backgroundColor = isOutline ? WHITE : WARNING;
  } else if (props.gray) {
    color = isOutline ? GRAY_LIGHT : LABEL;
    backgroundColor = isOutline ? WHITE : GRAY_LIGHT;
  } else if (props.purple) {
    color = isOutline ? PURPLE : WHITE;
    backgroundColor = isOutline ? WHITE : PURPLE;
  } else if (props.success) {
    color = isOutline ? SUCCESS : WHITE;
    backgroundColor = isOutline ? WHITE : SUCCESS;
  } else if (props.info) {
    color = isOutline ? INFO : WHITE;
    backgroundColor = isOutline ? WHITE : INFO;
  } else if (props.black) {
    color = isOutline ? BLACK : WHITE;
    backgroundColor = isOutline ? WHITE : BLACK;
  } else if (props.grayDark) {
    color = isOutline ? GRAY_DARK : WHITE;
    backgroundColor = isOutline ? WHITE : GRAY_DARK;
  } else if (props.successDark) {
    color = isOutline ? SUCCESS_DARK : WHITE;
    backgroundColor = isOutline ? WHITE : SUCCESS_DARK;
  } else if (props.purpleLight) {
    color = isOutline ? PURPLE_LIGHT : PRIMARY;
    backgroundColor = isOutline ? WHITE : PURPLE_LIGHT;
  } else if (props.white) {
    color = isOutline ? WHITE : GRAY_DARK;
    backgroundColor = isOutline ? TRANSPARENT : WHITE;
  } else if (props.foo) {
    color = isOutline ? FOO : WHITE;
    backgroundColor = isOutline ? WHITE : FOO;
  }

  const borderColor = isOutline ? color : null;
  const borderWidth = isOutline ? 1 : null;

  return { color, backgroundColor, borderColor, borderWidth };
};
